<div class="text-container">
    <p class="heading-h6-regular">Assignment List</p>
    <p class="paragraph-medium-regular">The exhaustive list of purchasing executives tasked with item-vendor tagging for their assigned item no. in the
        current document.</p>
    <div class="custom-table-wrapper--inner">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z3">
            <ng-container matColumnDef="purchasingExecutive">
                <th mat-header-cell *matHeaderCellDef> Purchasing Executive </th>
                <td mat-cell *matCellDef="let element"> {{getNameOfUser(element.purchasingExecutive)}} </td>
            </ng-container>

            <ng-container matColumnDef="itemNumber">
                <th mat-header-cell *matHeaderCellDef> Items </th>
                <td mat-cell *matCellDef="let element">
                    {{transformBackendItemIdsToFrontendItemIds(element.itemNumbersString)}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let element"> <button class='action-button'
                        [disabled]="!element.canTransfer || element.itemNumbersString.length == 0 || isLocked"
                        (click)="!isLocked && element.canTransfer && element.itemNumbersString.length>0 && transfer(element)"><mat-icon
                            svgIcon="transfer"></mat-icon></button> <button class='action-button'
                        [disabled]="!element.canVolunteer || element.itemNumbersString.length == 0 || isLocked"
                        (click)="!isLocked && element.canVolunteer && element.itemNumbersString.length>0 && volunteer(element)"><mat-icon
                            svgIcon="volunteer"></mat-icon></button></td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <app-button class="padBtn close-button" name="Close" (click)="closeMe()"></app-button>
</div>